angular.module('admin.reports').controller('BasicReportCtrl',
    function ($http, config, ReportsResource) {

        this.init = function () {
            this.page = 1;
            this.showAll = false;
            var today = new Date;
            var dateFromSession = sessionStorage.getItem('reports.basic.period');
            if (dateFromSession)
                this.month = new Date(dateFromSession);
            else
                this.month = new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0);

            this.loadReport();
        }

        this.changePeriod = function () {

            sessionStorage.setItem("reports.basic.period", this.month.toISOString());
            this.loadReport(1);
        }

        this.loadReport = function (resetPage) {

            if (resetPage)
                this.page = 1;


            ReportsResource.basicCustomers({
                month: this.month,
                page: this.page,
                showAll: this.showAll,
                limit: 20
            }, (response) => {
                this.report = response.data;
            });
        }
        this.exportToExcel = function () {

            var mm = ('0' + (this.month.getMonth() + 1)).substr(-2);
            var yyyy = this.month.getFullYear();
            var filename = `UsuariosBasicos_${yyyy}-${mm}.csv`;

            $http({
                url: config.api + '/api/v1/reports/basic-users-exceeding-views/export',
                params: {
                    month: this.month,
                    showAll: this.showAll
                },
                method: 'GET',
                responseType: 'arraybuffer'
            }).then((res) => {

                res.headers();
                var url = URL.createObjectURL(new Blob([res.data], { type: 'arraybuffer' }));
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.target = '_blank';
                a.click();
            });
        }

        this.init();
    });